/* We Live On Jewelry — product preview page (templates/page.product.json).
   Ported from the approved HTML_PREVIEW source's inline PDP script. The
   only functional change: product images are read from
   window.PDP_PRODUCTS, which the pdp-section section renders from real
   theme assets (asset_url), instead of the base64 data URIs the source
   page embedded directly in JS. Everything else — variant selection,
   quantity stepper, wishlist toggle, add-to-cart feedback — is preserved.
   The product list now comes from a collection; related products are rendered
   in Liquid by the pdp-related section. Runs only on the product preview template. */
(function () {
  'use strict';
  if (!window.PDP_PRODUCTS || !window.PDP_PRODUCTS.length) return;

  var PRODUCTS = window.PDP_PRODUCTS;

  function findProduct(slug) {
    for (var i = 0; i < PRODUCTS.length; i++) { if (PRODUCTS[i].slug === slug) return PRODUCTS[i]; }
    return null;
  }

  function getRequestedSlug() {
    var params = new URLSearchParams(window.location.search);
    return params.get('product');
  }

  var state = { product: null, size: null, metal: null, qty: 1 };

  function renderVariantGroup(container, options, selectedEl, onSelect, isPill) {
    if (!container) return;
    container.innerHTML = '';
    var group = container.closest('.pdp-variant-group');
    if (!options || !options.length) { if (group) group.style.display = 'none'; return; }
    if (group) group.style.display = '';
    options.forEach(function (opt, idx) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.setAttribute('role', 'radio');
      btn.setAttribute('aria-checked', idx === 0 ? 'true' : 'false');
      if (isPill) {
        btn.className = 'pdp-metal-swatch' + (idx === 0 ? ' is-active' : '');
        btn.innerHTML = '<span class="pdp-metal-dot" aria-hidden="true"></span>' + opt;
      } else {
        btn.className = 'pdp-size-btn' + (idx === 0 ? ' is-active' : '');
        btn.textContent = opt;
      }
      btn.addEventListener('click', function () {
        container.querySelectorAll('button').forEach(function (b) { b.classList.remove('is-active'); b.setAttribute('aria-checked', 'false'); });
        btn.classList.add('is-active');
        btn.setAttribute('aria-checked', 'true');
        if (selectedEl) selectedEl.textContent = opt;
        onSelect(opt);
      });
      container.appendChild(btn);
    });
    if (selectedEl) selectedEl.textContent = options[0];
    onSelect(options[0]);
  }

  function addToCartFeedback(btn, qty) {
    var original = btn.innerHTML;
    btn.innerHTML = '<svg viewBox="0 0 24 24" width="16" height="16" style="stroke:currentColor;fill:none;stroke-width:2"><polyline points="20 6 9 17 4 12"/></svg> Added!';
    btn.disabled = true;
    setTimeout(function () { btn.innerHTML = original; btn.disabled = false; }, 1600);
    var countEl = document.querySelector('.cart-count');
    if (countEl) countEl.textContent = String((parseInt(countEl.textContent || '0', 10) || 0) + qty);
  }

  function renderProduct(product) {
    state.product = product;

    var mainImage = document.getElementById('pdp-main-image');
    if (mainImage && product.image) { mainImage.src = product.image; mainImage.alt = product.alt; }
    var badgeEl = document.getElementById('pdp-badge');
    if (badgeEl) { if (product.badge) { badgeEl.textContent = product.badge; badgeEl.hidden = false; } else { badgeEl.hidden = true; } }

    var thumbs = document.getElementById('pdp-thumbs');
    if (thumbs) {
      thumbs.innerHTML = '';
      var images = product.images && product.images.length ? product.images : [product.image];
      if (images.length > 1) {
        images.forEach(function (src, i) {
          var b = document.createElement('button');
          b.type = 'button';
          b.className = 'pdp-thumb' + (i === 0 ? ' is-active' : '');
          b.innerHTML = '<img src="' + src + '" alt="">';
          b.addEventListener('click', function () {
            if (mainImage) mainImage.src = src;
            thumbs.querySelectorAll('.pdp-thumb').forEach(function (t) { t.classList.remove('is-active'); });
            b.classList.add('is-active');
          });
          thumbs.appendChild(b);
        });
      }
    }

    setText('pdp-eyebrow', product.category || 'Collection');
    setText('pdp-title', product.name);
    setText('pdp-price', product.priceFormatted);
    setText('pdp-mobile-price', product.priceFormatted);
    setText('pdp-desc', product.longDesc);
    setText('pdp-breadcrumb-current', product.name);

    var sizeLabelEl = document.getElementById('pdp-size-label');
    if (sizeLabelEl) sizeLabelEl.textContent = product.sizeLabel || 'Size';
    renderVariantGroup(document.getElementById('pdp-size-options'), product.sizes, document.getElementById('pdp-size-selected'), function (v) { state.size = v; }, false);
    renderVariantGroup(document.getElementById('pdp-metal-options'), product.metals, document.getElementById('pdp-metal-selected'), function (v) { state.metal = v; }, true);

    var qtyInput = document.getElementById('pdp-qty-input');
    if (qtyInput) qtyInput.value = 1;
    state.qty = 1;

    document.querySelectorAll('[data-animate]').forEach(function (el) { el.classList.add('is-visible'); });
  }

  function setText(id, value) {
    var el = document.getElementById(id);
    if (el) el.textContent = value;
  }

  (function () {
    var slug = getRequestedSlug();
    var product = (slug && findProduct(slug)) || PRODUCTS[0];
    renderProduct(product);
  })();

  // ── Quantity stepper ──
  (function () {
    var input = document.getElementById('pdp-qty-input');
    var minus = document.getElementById('pdp-qty-minus');
    var plus = document.getElementById('pdp-qty-plus');
    if (!input) return;
    if (minus) minus.addEventListener('click', function () {
      var v = Math.max(1, (parseInt(input.value, 10) || 1) - 1);
      input.value = v; state.qty = v;
    });
    if (plus) plus.addEventListener('click', function () {
      var v = Math.min(99, (parseInt(input.value, 10) || 1) + 1);
      input.value = v; state.qty = v;
    });
    input.addEventListener('change', function () {
      var v = Math.min(99, Math.max(1, parseInt(input.value, 10) || 1));
      input.value = v; state.qty = v;
    });
  })();

  // ── Wishlist toggle ──
  var wishlistBtn = document.getElementById('pdp-wishlist-btn');
  if (wishlistBtn) {
    wishlistBtn.addEventListener('click', function () {
      var isActive = this.classList.toggle('is-active');
      this.setAttribute('aria-pressed', String(isActive));
    });
  }

  // ── Add to cart (main + sticky mobile bar) ──
  var addBtn = document.getElementById('pdp-add-to-cart');
  var mobileAddBtn = document.getElementById('pdp-mobile-add-to-cart');
  if (addBtn) addBtn.addEventListener('click', function () { addToCartFeedback(this, state.qty); });
  if (mobileAddBtn) mobileAddBtn.addEventListener('click', function () { addToCartFeedback(this, state.qty); });
})();
